<template>
  <div class="row">
    <div class="col-md-12 text-left">
      <modal :show.sync="ModalDetailOrder">
        <template slot="header">
          <h5 class="modal-title sub_title" id="exampleModalLabel2">Detalle de la Orden </h5>
          <span v-if="auditoryStatus" style="margin-left: 10px" class="badge badge-info">Orden Auditada</span>
        </template>
        <div class="row " v-if="(order.order_id > 0)">
          <div class="col-12 text-right pb-2">
            <base-button type="success" class="align-content-end btn-sm" @click="GetLogOrder(order.order_id)">
              Ver Log de la orden
            </base-button>
            <base-button v-if="generateneworder === true" type="success" @click="Reorder()"
                         class="align-content-end btn-sm">
              Ordenar Productos Pendientes
            </base-button>
            <modal :show.sync="ModalLog">
              <template slot="header">
                <h5 class="modal-title sub_title" id="modallog">Log de la orden {{ order.order_id }}</h5>
              </template>
              <div class="container">
                <div class="container-fluid">
                  <div class="table-responsive table-flush">
                    <table class="table align-items-left">
                      <thead class="table-light" align="left">
                      <th>Usuario</th>
                      <th>Fecha</th>
                      <th>Accion</th>
                      <th >Descripción</th>


                      </thead>
                      <tbody class="list" v-if="log.length > 0">
                      <tr v-for="(l,i) in log" :key="i">
                        <td>{{ l.User.name }}</td>
                        <td>{{ formatedate(l.date) + ' ' + formatehora(l.date) }}</td>
                        <td>{{ l.made }}</td>
                        <td align="left" >{{ l.description }}</td>

                      </tr>

                      </tbody>
                      <tr v-if="log.length == 0">
                        <td colspan="3">No hay datos para mostrar</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <template slot="footer">
              </template>
            </modal>
            <modal :show.sync="Modalnew_order">
              <template slot="header">
                <h5 class="modal-title sub_title" id="modalNelorder">Ordenar pendientes de la orden {{
                    order.order_id
                  }}</h5>

              </template>
              <div class="container">
                <div class="container-fluid">
                  <div class="table-responsive table-flush" style="max-height: 300px">
                    <table class="table align-items-center">
                      <thead class="table-light">
                      <th>Producto</th>
                      <th>SKU</th>
                      <th>Tipo Uni</th>
                      <th style="width: 10%">Cant a Pedir</th>
                      <th>% IVA</th>
                      <th>IVA</th>
                      <th>Precio</th>
                      <th>Total</th>
                      <th>Nota</th>
                      </thead>
                      <tbody class="list">
                      <tr v-for="(prod,i) in new_order.neworderproduct" :key="i">
                        <td>
                          {{ prod.name }}
                        </td>
                        <td>
                          {{ prod.sku }}
                        </td>
                        <td>
                          <multiselect v-model="new_order.neworderproduct[i].newunit"
                                       :options="getunit(prod.product.unit)" :searchable="false"
                                       :close-on-select="true" :show-labels="false"
                                       @input="changeunitnew(i)"
                                       track-by="unit_type_id" label="unit_name"
                                       placeholder="Seleccionar"></multiselect>
                        </td>

                        <td>
                          <input class="form-control" type="number" min="1" :id="prod.sku" @input="newtotalreorder()"
                                 v-model="new_order.neworderproduct[i].newquantity">
                        </td>
                        <td>
                          {{ prod.tax_product }}
                        </td>
                        <td>
                          {{ prod.tax_value }}
                        </td>
                        <td>
                          {{ formatPrice(prod.newprice) }}
                        </td>
                        <td>
                          {{
                            formatPrice(prod.newprice * prod.newquantity + prod.tax_value)
                          }}
                        </td>
                        <td>
                          <input class="form-control " type="text" :id="'nota'+prod.sku"
                                 v-model="new_order.neworderproduct[i].newnota">
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <h4>Total Orden: {{ formatPrice(totalreorder) }}</h4>
                  </div>
                </div>
              </div>
              <template slot="footer">
                <base-button @click="NewOrder()" class="btn_submit">Crear Orden</base-button>
                <base-alert type="danger" v-if="error">
                  <strong>{{ error }}</strong>
                </base-alert>

              </template>
              <div class="row">
                <div class="col-12">
                  <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                                 label="Guardando"></base-progress>
                </div>
              </div>
            </modal>
          </div>
          <div class="col-5 row">

            <div class="col-6">
              <H2 class="sub_title">Orden # {{ order.order_id }}</H2>
              <h4 class="sub_title_content" v-if="order.Restaurant != null">Restaurante:
                <span>{{ order.Restaurant.name }}</span></h4>
              <h4 class="sub_title_content" v-if="order.User != null">Usuario:
                <div v-for="(u,i) in order.User" :key="i">
                  <span v-if="u.user_type_id.user_type_id != 6">{{ u.name + ' ' + u.last_name }}</span>
                </div>
              </h4>
              <h4 class="sub_title_content" v-if="order.shipping_amount != null">Valor Envio:
                <span>${{ formatPrice(order.shipping_amount) }}</span></h4>
              <h4 class="sub_title_content" v-if="order.total_sale != null">Valor Compra: <span>${{
                  formatPrice(order.total_sale +
                      order.tax_amount)
                }}</span></h4>
              <h4 class="sub_title_content" v-if="order.total_sale != null">Total a Pagar:
                <span>${{ formatPrice(order.total_sale + order.tax_amount + order.shipping_amount) }}</span></h4>

              <div v-for="(item,i) in order.Paymethod" :key="i">
                <h4 class="sub_title_content">Forma de pago: <span>{{ item.payment_name }}</span></h4>
                <h4 class="sub_title_content" v-if="item.paymethod_id === 1 && order.Transaction === null ">Estado Pago:
                  <span>Pendiente de transacción</span></h4>
              </div>
              <h4 v-if="order.Transaction != null">Transacción:
                <span>{{ order.Transaction.transaction_state_label }}</span></h4>


            </div>
            <div class="col-6" v-if="order.shipping">
              <div v-for="(item,i) in  parsearr(order.shipping)" :key="i">
                <h4 class="sub_title_content">Ciudad: <span>{{ item.city }}</span></h4>
                <h4 class="sub_title_content">Barrio: <span>{{ item.neighborhood }}</span></h4>
                <h4 class="sub_title_content">Dirección: <span>{{ item.address }}</span></h4>
                <h4 class="sub_title_content">Teléfono: <span>{{ item.phone }}</span></h4>
                <h4 class="sub_title_content">Entregar a : <span>{{ item.deliver_to }}</span></h4>
                <h4 class="sub_title_content">Referencia: <span>{{ item.observation }}</span></h4>
              </div>
              <h4 class="sub_title_content">Fecha Orden: <span>{{ formatedate(order.order_date) }}</span></h4>
              <h4 class="sub_title_content">Hora Orden: <span>{{ formatehora(order.order_date) }}</span></h4>
            </div>


          </div>
          <div class="col-7">
            <div class="table-responsive table-flush" style="max-height: 300px">
              <table class="table align-items-center">
                <thead class="table-light">
                <th>Producto</th>
                <th>SKU</th>
                <th>Uni</th>
                <th>Cant Pedida</th>
                <th>Cant Enviada</th>
                <th>Prod Pend</th>
                <th>% IVA</th>
                <th>IVA</th>
                <th>Precio</th>
                <th>Total Pedido</th>
                <th>Total Enviado</th>
                <th>Nota</th>
                </thead>
                <tbody class="list">
                <tr v-for="(item,i) in order.orderproduct" :key="i">
                  <td>
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.sku }}
                  </td>
                  <td>
                    {{ item.unit }}
                  </td>
                  <td>
                    {{ item.quantity }}
                  </td>
                  <td>
                    {{ item.quantityCheck }}
                  </td>
                  <td style="text-align: right">

                    <base-checkbox disabled v-model="item.is_missing"></base-checkbox>
                  </td>
                  <td>
                    {{ item.tax_product }}
                  </td>
                  <td>
                    {{ item.tax_value }}
                  </td>
                  <td>
                    {{ formatPrice(item.price) }}
                  </td>
                  <td>
                    {{ formatPrice(totalitem(item.unit, item.price, item.quantity) + item.tax_value) }}
                  </td>
                  <td>
                    {{ formatPrice(totalitem(item.unit, item.price, item.quantityCheck) + item.tax_value) }}
                  </td>
                  <td>{{ item.nota }}</td>
                </tr>
                </tbody>


              </table>

            </div>
          </div>

          <div class="col-12" style="border-bottom: #2b2b58 solid"/>
          <div class="col-12">
            <label class="typo__label sub_title_content">Despachadores</label>
            <multiselect
                v-model="userselect"
                :custom-label="customLabel"
                @input="changedespachador"
                :searchable="true"
                :close-on-select="true"
                :multiple="true"
                track-by="user_id" label="last_name"
                placeholder="Seleccione un despachador"
                :options="users"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong>{{ option.name + ' ' + option.last_name }}</strong>
              </template>
            </multiselect>
          </div>
        </div>
        <template slot="footer">

          <div v-if="(order.order_id > 0)" class="col-12">

            <label class="typo__label">Cambiar Estado:</label>
            <div class="custom-control custom-radio custom-control-inline radio-default-acre"
                 v-for="status in orderstatus"
                 :key="status.id">
              <PrettyRadio
                  :id="status.order_id"
                  @change="changestatus(status.order_status_id,order.order_id)"
                  :name="status.order_status_id+''+order.order_id"
                  :value="status.order_status_id"
                  :checked="order.OrderStatus.order_status_id === status.order_status_id">{{
                  status.status.replace(/\b\w/g, function (l) {
                    return l.toUpperCase()
                  })
                }}
              </PrettyRadio>
            </div>
          </div>

        </template>
      </modal>

    </div>
  </div>
</template>

<script>
import {bus} from './bus-order'
import {order_service} from "../../services/order/OrderService";
import swal from "sweetalert";
import PrettyRadio from 'pretty-checkbox-vue/radio';
import _ from "lodash";

export default {
  name: "DetailOrder",
  components: {PrettyRadio},
  data() {
    return {
      auditoryStatus: false,
      itemsAudited: '',
      error: '',
      progress: 0,
      totalreorder: 0,
      ModalLog: false,
      generateneworder: false,
      ModalDetailOrder: false,
      Modalnew_order: false,
      order: [],
      new_order: [],
      users: [],
      log: [],
      user_session: [],
      userselect: [],
      updateorder: {
        order_id: 0,
        OrderStatus: {
          order_status_id: 0
        }
      },
      orderstatus: []
    }
  },
  methods: {
    NewOrder() {
      this.progress = 50
      var f = new Date()
      let day = f.getDate()
      let month = f.getMonth() + 1
      let year = f.getFullYear()

      if (month < 10) {

        this.new_order.order_date = `${year}-0${month}-${day}`
      } else {
        this.new_order.order_date = `${year}-${month}-${day}`

      }
      const updateorder = {
        order_id: this.order.order_id,
        user_id: this.user_session.user_id,
        orderproduct: []
      }
      const data = {
        order_date: this.new_order.order_date,
        tax_amount: this.new_order.tax_amount,
        shipped_date: this.new_order.order_date,
        shipping_amount: this.new_order.shipping_amount,
        total_sale: this.totalreorder,
        shipping: this.new_order.shipping,
        ship: "[]",
        User: this.order.User,
        user_id: this.user_session.user_id,

        OrderStatus: {
          order_status_id: 6
        },
        Paymethod: this.new_order.Paymethod,
        orderproduct: []
      }
      if (this.order.Restaurant != undefined) {
        data.Restaurant = {'restaurant_id': this.order.Restaurant.restaurant_id}
      }
      //console.log(this.new_order.neworderproduct)
      for (const i in this.new_order.neworderproduct) {
        updateorder.orderproduct.push({
          'order_products_id': this.new_order.neworderproduct[i].order_products_id,
          "is_missing": false
        });

        data.orderproduct.push({
          'product_id': this.new_order.neworderproduct[i].product.product_id,
          'sku': this.new_order.neworderproduct[i].sku,
          'name': this.new_order.neworderproduct[i].name,
          'quantity': this.new_order.neworderproduct[i].newquantity,
          'price': this.new_order.neworderproduct[i].newprice,
          'tax_product': this.new_order.neworderproduct[i].tax_product,
          'tax_value': this.new_order.neworderproduct[i].tax_value,
          "unit": this.new_order.neworderproduct[i].unit,
          "nota": this.new_order.neworderproduct[i].newnota,
          "details": "",
          "is_missing": false,
          "unitCheck": "",
          "quantityCheck": 0
        })
      }
      order_service.UpdateOrderNew(updateorder)
      order_service.CreateOrder(data)
      this.Modalnew_order = false
    },

    changeunitnew(x) {
      var des = 0
      console.log(this.new_order.neworderproduct[x].newunit)
      this.new_order.neworderproduct[x].unit = this.new_order.neworderproduct[x].newunit.shotname
      const sku = _.filter(this.new_order.neworderproduct[x].product.Sku, ['sku', this.new_order.neworderproduct[x].sku]);
      //console.log(sku)
      if (this.order.Restaurant.Discounts.percent != undefined) {
        des = this.order.Restaurant.Discounts.percent
      } else {
        des = 0
      }

      if (this.new_order.neworderproduct[x].newunit.shotname === 'Uni') {

        this.new_order.neworderproduct[x].newprice = (sku[0].unit_price) - ((sku[0].unit_price * des) / 100)
      }
      if (this.new_order.neworderproduct[x].newunit.shotname === 'GR') {
        this.new_order.neworderproduct[x].newprice = (sku[0].price / 1000) - (((sku[0].price / 1000) * des) / 100)
      }
      if (this.new_order.neworderproduct[x].newunit.shotname === 'KL') {

        this.new_order.neworderproduct[x].newprice = sku[0].price - (sku[0].price * des) / 100
      }
      this.newtotalreorder()
    },
    getunit(unit) {
      return JSON.parse(unit)

    },
    newtotalreorder() {
      this.totalreorder = 0
      for (const i in this.new_order.neworderproduct) {
        this.totalreorder = this.totalreorder + (this.new_order.neworderproduct[i].newprice * Number(this.new_order.neworderproduct[i].newquantity))
      }
    },
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    Reorder() {

      order_service.GetSkuOrder(this.order.order_id)

    },
    totalitem(uni, price, cant) {
      if (uni === 'Uni') {
        return cant * price
      }
      if (uni === 'GR') {
        return cant * price

      }
      if (uni === 'KL') {
        return cant * price

      }
    },
    GetLogOrder(order_id) {
      this.ModalLog = true
      order_service.GetLogOrder(order_id)
    },
    DetailOrder() {
      this.order = []
      this.new_order = []
      this.users = []
      this.log = []
      this.user_session = []
      this.userselect = []
      this.updateorder = []
      this.ModalDetailOrder = !this.ModalDetailOrder

    },
    formatedate(value) {
      var date = new Date(value);
      return date.toISOString().slice(0, 10);
    },
    formatehora(fecha) {
      var fechas = new Date(fecha)
      return fechas.toLocaleTimeString()
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    parsearr(arr) {
      return JSON.parse(arr)
    },
    changestatus(order_status_id, order_id) {

      swal("¿Seguro que va cambiar el estado de la orden?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {

              case "Aceptar":
                this.order.OrderStatus.order_status_id = order_status_id
                this.updateorder.order_id = order_id
                this.updateorder.OrderStatus.order_status_id = order_status_id
                this.updateorder.user_id = this.user_session.user_id
                order_service.UpdateOrderStatus(this.updateorder)
                break;
              default:
                swal("No se hicieron cambios");

            }
          });

    },
    changedespachador() {

      swal("¿Seguro que va cambiar el despachador?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {

              case "Aceptar":
                var order_user = [];
                //console.log(order_user)
                //agregar usuarios existentes en la orden que no sean despachadores
                if (this.order.User.length > 0) {
                  for (const u in this.order.User) {
                    if (this.order.User[u].user_type_id.user_type_id != 4)
                      order_user.push({"user_id": this.order.User[u].user_id})
                  }
                }
                for (const us in this.userselect) {
                  order_user.push({"user_id": this.userselect[us].user_id})
                }

                order_service.UpdateOrderStatus({
                  'order_id': Number(this.order.order_id),
                  'User': order_user,
                  'user_id': this.user_session.user_id
                })

                break;
              default:
                swal("No se hicieron cambios");

            }
          });

    }

  },
  beforeCreate() {
    bus.$on('ResponseUpdateOrderNew', (response) => {
      if (response) {
        this.order = []
        this.new_order = []
        this.ModalDetailOrder = false
        this.ModalDetailOrder = false
      }

    })
    bus.$on('ShowDetailOrder', (order1) => {
      this.order = []
      this.new_order = []
      //console.log(order1)
      if (order1) {
        this.userselect = []
        this.ModalDetailOrder = true
        this.auditoryStatus = false
        this.order = order1
        for (const i in order1.orderproduct) {
          if (order1.orderproduct[i].is_missing === true) {
            this.generateneworder = true
          }
        }
        for (const u in order1.User) {
          if (order1.User[u].user_type_id.user_type_id === 4) {
            this.userselect.push(order1.User[u])
          }
        }
        this.itemsAudited = 0
        if (this.order.orderproduct.length > 0) {
          _.each(this.order.orderproduct, (o) => {
            if (o.audit) {
              this.itemsAudited += 1
            }
          })
          if (this.itemsAudited === this.order.orderproduct.length) {
            this.auditoryStatus = true
          }
        }

      }
    })
  },
  beforeMount() {
    bus.$on('GetSkuOrder', (response => {
      try {
        this.Modalnew_order = true
        this.new_order = response
        if (typeof this.new_order.neworderproduct != undefined) {
          const pending = _.filter(this.new_order.orderproduct, ['is_missing', true]);
          this.new_order.neworderproduct = pending
          console.log(pending)
          if (this.new_order.neworderproduct.length > 0) {
            this.totalreorder = 0
            //console.log(this.new_order.neworderproduct)
            for (var op = 0; op <= this.new_order.neworderproduct.length; op++) {
              //console.log(this.new_order.neworderproduct[op])
              if (this.new_order.neworderproduct[op].product != undefined) {
                this.new_order.neworderproduct[op].newunit = _.filter(JSON.parse(this.new_order.neworderproduct[op].product.unit), ['shotname', this.new_order.neworderproduct[op].unit]);
                //console.log(JSON.parse(this.new_order.neworderproduct[op].newunit))
                //console.log(this.new_order.neworderproduct[op].unit)
                this.new_order.neworderproduct[op].newquantity = Number(this.new_order.neworderproduct[op].quantity) - this.new_order.neworderproduct[op].quantityCheck
                this.new_order.neworderproduct[op].newprice = this.new_order.neworderproduct[op].price
                this.new_order.neworderproduct[op].newnota = this.new_order.neworderproduct[op].nota
                this.totalreorder = this.totalreorder + (this.new_order.neworderproduct[op].price * Number(this.new_order.neworderproduct[op].newquantity))
              }
            }
          }

        }
      } catch (err) {
        console.log(err.message);
      }

    }))
  },
  created() {
    this.user_session = JSON.parse(sessionStorage.getItem('user'))
    order_service.GetUsersByType(4)
    order_service.GetAllOrderStatus()

    bus.$on('ResponseCreateOrder', (response) => {
      if (response) {
        this.error = ''
        this.progress = 0
        this.totalreorder = 0
        this.ModalLog = false
        this.generateneworder = false
        this.ModalDetailOrder = false
        this.Modalnew_order = false
        this.order = []
        this.new_order = []
      }
    })

    bus.$on('GetUsersByType', (response => {
      //console.log(response)
      this.users = response
    }))

    bus.$on('GetLogOrder', (response) => {
      this.log = response
    })

    bus.$on('GetAllOrderStatus', (response) => {
      this.orderstatus = []
      this.orderstatus = response
    })
    bus.$on('ResponseUpdateOrderStatus', (response) => {
      if (response.status === 200) {
        order_service.GetAllOrder()
        swal({
          icon: "success",
          text: "Se Actualizo El Estado De La Orden Correctamente",
          button: "Aceptar"
        })
      } else {
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Actualizo El Estado De La Orden Correctamente",
          button: "Aceptar"
        })
      }
    })

  }
}
</script>

<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .modal-body .row .col-5 {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0;
    margin: 0 auto;
  }

  .modal-body .row .col-7 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .modal-footer > div {
    display: flex;
    flex-wrap: wrap;
  }

  .modal-footer > div > label {
    width: 100%;
  }

  .modal-footer > div > div {
    width: 50%;
    margin: 0 auto;
    padding: 0;
    height: 4em;
  }

  .radio-default-acre .pretty label::before, .radio-default-acre .pretty label::after {
    top: 0.1em !important;
  }
}
</style>

<style>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .radio-default-acre .pretty label::before, .radio-default-acre .pretty label::after {
    top: 0.1em !important;
  }
}
</style>
